import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import DropdownView from 'core/views/dropdown';


export default Backbone.View.extend({
  data: null,

  initialize: function () {
    _.bindAll.apply(_, [this].concat(_.functions(this)));

    this.form = $('#account-profile-form', this.$el);
  },

  render: function () {
    this.$el.on('show.bs.modal', this.clearForm);
    this.$el.on('shown.bs.modal', this.loadProfile);
  },

  renderModal: function (partial) {
    // Cache the initial form HTML
    this.data = this.data || partial;
    // Render the form
    this.form.html(partial);
    _.each($('.form-dropdown'), function (dropdown) {
      new DropdownView({ el: dropdown });
    });
    $('.profile-save', this.$el).on('click', this.saveProfile);
  },

  clearForm: function () {
    this.form.html('');
  },

  loadProfile: function () {
    // Get the rendered form body from the Django view. Use the cache
    // if it exists
    if (this.data) {
      this.renderModal(this.data);
    } else {
      $.get(this.form.attr('data-action'), {}, this.renderModal);
    }
  },

  saveProfile: function () {
    var self = this;
    const action = this.form.attr('data-action');
    $.post(action, this.form.serialize(), function (data) {
      if (_.has(data, 'redirect_to')) {
        // Non-MOS users gets a redirect
        window.location.replace(data.redirect_to);
      } else if (_.has(data, 'template')) {
        // Override the HTML with the new template
        self.form.html(data.template);
        // If user is on the accounts page, then we need to update the
        // phone_number if:
        // User is a MOS user and user is changing his/her phone_number
        // User is updating his/her phone_number to be an empty string
        $("#account input[name='phone_number']").val(data.phone_number);
        // Clear out the cache
        self.data = null;
      } else {
        // There has been an error, re-render the view with the
        // provided html (data)
        self.renderModal(data);
      }
    });
  }
});



// WEBPACK FOOTER //
// ./static/js/views/account-profile.js